/* globals angular */

'use strict';

var app = angular.module('saturn.filter.filters', []);

var treeFilter = require('./treeFilter');
app.filter('sbTreeFilter', [treeFilter]);
var highlightFilter = require('./highlightFilter');
app.filter('sbHighlight', ['$sce', highlightFilter]);


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/filter/es5/filters/index.js